export default __webpack_public_path__ + "static/media/bg-section-top-mobile-1.2c00de76.svg";